export enum NotificationLevel {
    Success = 0,
    Info = 1,
    Error = 2,
}

export default NotificationLevel;
